import { styled, css, mixins, theme } from 'ui/theme';
import { ButtonGhost } from '../Button';

const baseStyles = css`
  color: ${theme.colors.build.mediumLight1};
  margin: ${theme.space[0]};
`;

export const Heading = styled('div')`
  > h1,
  > h2,
  > h3,
  > h4,
  > h5,
  > h6 {
    ${baseStyles};
    // Align
    &[data-text-align='center'] {
      text-align: center;
    }
    &[data-text-align='left'] {
      text-align: left;
    }
    &[data-text-align='right'] {
      text-align: right;
    }

    // Level
    &[data-level='1'] {
      ${mixins.h1}
    }
    &[data-level='2'] {
      ${mixins.h2}
    }
    &[data-level='3'] {
      ${mixins.h3}
    }
    &[data-level='4'] {
      ${mixins.h4}
    }
    &[data-level='5'] {
      ${mixins.h5}
    }
    &[data-level='6'] {
      ${mixins.h6}
    }

    // Colors
    &[data-color='brand-1'] {
      color: ${theme.colors.action.nonInteractive.emphasis};
    }

    font-weight: 500;
  }

  &[data-has-link='true'] {
    display: flex;
  }
`;

export const ButtonShowAll = styled(ButtonGhost)`
  border-color: ${theme.colors.action.navigation.standard.static};
  width: 78px;
  height: 32px;
  padding: 6px 10px;
  align-content: center;
  flex-wrap: wrap;
  margin-left: 16px;
`;
